import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAddProductsToPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ plan_id, product_ids }: { plan_id: number; product_ids: number[] }) =>
      await apiClient.addProductsToPricingPlan(product_ids, { params: { id: plan_id } }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["pricing_plans"],
      });
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "pricing_plans" }],
      });
      void queryClient.invalidateQueries({
        queryKey: [{ endpoint: "/api/data_report/product_report" }],
      });
    },
  });
};
